module.exports = __webpack_public_path__ + "static/media/expert1.faae8dd8.png";